// extracted by mini-css-extract-plugin
export default {"managerWrapper":"DiscountMembershipManager_managerWrapper__M14zY"};